var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import RequiredMixin from "../../../components/renderHeader/RequiredMixin";
var PrintBody = (function (_super) {
    __extends(PrintBody, _super);
    function PrintBody() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currRow = null;
        _this.defaultSort = { prop: 'sort', order: 'ascending' };
        return _this;
    }
    PrintBody.prototype.changeCurrRow = function (row) {
        this.currRow = row;
    };
    PrintBody.prototype.addCustomRow = function () {
        var _this = this;
        var row = {
            column_type: 2,
            is_hidden: 0,
            column_width: 15,
            is_wrap: 0,
            is_summary: 0,
            is_summary_edit: 0,
            align: 2,
            key: '',
            value: '',
            sort: (this.configModel.table_main_column.length + 1)
        };
        this.configModel.table_main_column = (this.configModel.table_main_column).concat([row]);
        this.$refs.bodyTable.sort('sort', 'descending');
        this.$nextTick(function () {
            _this.$validator.validateScopes();
        });
    };
    PrintBody.prototype.delCustomRow = function () {
        var _this = this;
        if (!this.currRow || this.currRow.column_type != 2) {
            return;
        }
        this.$confirm('您确定要删除吗？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                _this.configModel.table_main_column = _this.configModel.table_main_column.filter(function (v) {
                    return v != _this.currRow;
                });
                _this.currRow = null;
                _this.$message.success('删除成功！');
                _this.$nextTick(function () {
                    _this.$validator.validateScopes();
                });
            }
        }).catch(function () {
        });
    };
    __decorate([
        Prop({
            type: Object
        })
    ], PrintBody.prototype, "configModel", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], PrintBody.prototype, "fontSizeList", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], PrintBody.prototype, "yesOrNoList", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], PrintBody.prototype, "textAlignList", void 0);
    __decorate([
        Prop({
            type: Boolean
        })
    ], PrintBody.prototype, "readonly", void 0);
    PrintBody = __decorate([
        Component({
            mixins: [RequiredMixin],
        })
    ], PrintBody);
    return PrintBody;
}(Vue));
export default PrintBody;
